import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from '@/constants/pagination'
import { OfflineConsultation } from '@/core/offline'
import { useMemo, useState } from 'react'

export type FilterState = {
  searchText: string
  page: number
  itemsPerPage: number
}

export function useConsultations(consultations: OfflineConsultation[]) {
  const [filter, setFilter] = useState<FilterState>({
    searchText: '',
    page: 1,
    itemsPerPage: DEFAULT_ROWS_PER_PAGE_OPTIONS[0],
  })

  const filteredConsultations = useFilterConsultations(consultations, filter.searchText)
  const paginatedConsultations = usePaginateConsultations(filteredConsultations, filter.page, filter.itemsPerPage)

  return {
    consultations: paginatedConsultations,
    page: filter.page,
    itemsPerPage: filter.itemsPerPage,
    rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
    setFilter,
    totalConsultations: filteredConsultations.length,
  }
}

function useFilterConsultations(consultations: OfflineConsultation[], searchText: string) {
  return useMemo(
    () =>
      consultations.filter((consultation) => {
        // Handle both string and object patient references
        const patient = typeof consultation.patient === 'string' ? null : consultation.patient

        if (!patient) return false

        return (
          patient.userInfo.name.toLowerCase().includes(searchText) ||
          patient.userInfo.surname.toLowerCase().includes(searchText) ||
          consultation.commentaire?.toLowerCase().includes(searchText)
        )
      }),
    [consultations, searchText]
  )
}

function usePaginateConsultations(consultations: OfflineConsultation[], page: number, itemsPerPage: number) {
  return useMemo(() => consultations.slice((page - 1) * itemsPerPage, page * itemsPerPage), [consultations, page, itemsPerPage])
}
